export default {
  SUPPORT_EMAIL: 'support@plentifulapp.com',
  TITLE: 'Plentiful for Neighbors',
};
